export const appMenuNames = new Map([
  ['ameriprise-client-relationship-guide', 'crg-main-menu'],
  ['financial-institutions-group', 'afig-main-menu'],
  ['retirement-income-guide', 'rig-main-menu'],
  ['retirement-income-guide-x', 'rig-main-menu'],
])
